import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export const ITEM_HEIGHT = 47;
export const ITEM_HEIGHT_DOWN_XS = 60;

export default makeStyles((theme: MuiTheme) => ({
  dropDownSearchList: {
    width: "100%",
    height: "auto",
    maxHeight: "293px",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxHeight: "initial"
    }
  },
  dropDownSearchListItem: {
    cursor: "pointer",
    height: ITEM_HEIGHT,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      height: ITEM_HEIGHT_DOWN_XS
    }
  },
  rowOdd: {
    backgroundColor: "#fafafa"
  },
  rowEven: {
    backgroundColor: theme.palette.common.white
  },
  searchNoResults: {
    width: "100%"
  },
  noSearchResultButton: {
    height: "70vh"
  },
  searchLoader: {
    paddingTop: 8,
    paddingBottom: 8
  },
  activeDropDownSearchListItem: {
    backgroundColor: "rgba(0, 0, 0, 0.04)"
  }
}));
